import React from "react";
import createClass from "create-react-class";

import Recaptcha from "react-grecaptcha";
import { isMobile } from "react-device-detect";
import { sendSms } from "../../../utils/ServerCalls";
import { deLocalize } from "../../../utils/NumberConvertor";
import DefaultDownloadLinks from "../../../config/DownloadLinks";

const DownloadSms = createClass({
  getInitialState() {
    return {
      Message: null,
      isCaptcha: false,
      phoneValue: ""
    };
  },
  render() {
    return (
      <div className="Download-Sms">
        <p>برای دریافت لینک دانلود، شماره خود را وارد کنید.</p>
        <div className="Fields">
          <form>
            <div className="Row">
              <input
                type="tel"
                className="Phone Phone-Small"
                ref="phone"
                pattern="^[0-9,۰-۹]{11}$"
                placeholder=" شماره موبایل"
                onChange={this.handleChange}
              />
              <div
                className={
                  "Send-Button" + (isMobile ? " Send-Button-Small" : "")
                }
                onClick={this.sendSms}
              >
                ارسال لینک دانلود
              </div>
            </div>
            {this.state.isCaptcha && (
              <Recaptcha
                sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
                callback={this.captchaVerified}
                locale={"fa"}
                expiredCallback={this.captchaExpired}
              />
            )}
          </form>
          {this.state.Message && (
            <div className="Message" style={{ color: this.state.messageColor }}>
              {this.state.Message}
            </div>
          )}
        </div>
      </div>
    );
  },
  captchaVerified(e) {
    this.setState({
      isCaptcha: false,
      captcha: e
    });
    this.sendSms();
  },
  handleChange(e) {
    this.setState({
      phoneValue: e.target.value
    });
  },
  sendSms() {
    const { phoneValue } = this.state;
    if (!this.refs.phone || !this.refs.phone.checkValidity()) {
      this.setState({
        Message: "لطفا شماره خود را به درستی وارد کنید",
        messageColor: "red",
        phoneValue: ""
      });
      setTimeout(this.setState.bind(this, { message: null }), 3000);
      return;
    }
    let phone = deLocalize(this.refs.phone.value.trim());
    let data = { phone };
    if (this.state.captcha) {
      data["g-recaptcha-response"] = this.state.captcha;
    }
    if (this.props.links) {
      data.link = this.props.links.sms_link;
    }
    this.setState({
      Message: "در حال ارسال درخواست...",
      messageColor: "#fff"
    });
    sendSms(data, this.smsSent);
  },
  captchaExpired() {
    this.setState({
      Message: ".زمان پاسخگویی شما به پایان رسیده است",
      messageColor: "#f93030",
      captcha: null
    });
  },
  smsSent(data) {
    let statesData = {};

    switch (data.status) {
      case 200:
        statesData = {
          Message: `لینک ‌های دانلود با موفقیت به شماره ${this.state.phoneValue} ارسال شد`,
          messageColor: "#3cb567"
        };
        this.refs.phone.value = "";

        break;

      case 429:
        statesData = { isCaptcha: true };
        setTimeout(
          this.setState.bind(this, { Message: null, captcha: null }),
          1000
        );

        break;

      case 400:
        statesData = {
          Message: ".لطفا شماره خود را به درستی وارد کنید",
          messageColor: "#f93030"
        };

        break;

      case 405:
        statesData = {
          Message: ".تعداد مجاز ارسال پیام برای شما به پایان رسیده است",
          messageColor: "#f93030"
        };
        break;

      default:
        statesData = {
          Message: ".مشکلی در فرآیند ارسال وجود داشت، لطفا بعدا تلاش کنید",
          messageColor: "#f93030"
        };
        break;
    }

    this.setState(statesData);

    setTimeout(
      this.setState.bind(this, { Message: null, captcha: null }),
      3000
    );
  }
});

export default DownloadSms;



// WEBPACK FOOTER //
// ./src/js/components/Pages/DownloadPage/DownloadSms.react.js